"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetSelectedModel = exports.GetModelsList = exports.GetModelTypesForDownload = exports.GetModelNameFromID = void 0;
var GetModelsList = exports.GetModelsList = function GetModelsList() {
  return [{
    id: "1",
    value: "1",
    label: "Data:27b (Advanced image analysis engine optimized for high-accuracy visual understanding)"
  }, {
    id: "2",
    value: "2",
    label: "Data:11b (Lightweight image analysis model designed for fast, efficient visual inference)"
  }];
};
var GetModelTypesForDownload = exports.GetModelTypesForDownload = function GetModelTypesForDownload(downloadedModels) {
  return GetModelsList().filter(function (model) {
    return !downloadedModels.some(function (downloaded) {
      return downloaded.id === model.value;
    });
  });
};
var GetSelectedModel = exports.GetSelectedModel = function GetSelectedModel(value) {
  return GetModelsList().find(function (model) {
    return model.value === value;
  }) || {
    value: value,
    label: value,
    id: value
  };
};
var GetModelNameFromID = exports.GetModelNameFromID = function GetModelNameFromID(modelID) {
  var model = GetModelsList().find(function (m) {
    return m.value === modelID;
  });
  return model ? model.label : modelID;
};